import React from 'react';
import '../service-requests/service-request.css';
import Modal, { IModalChildProps } from '../../common/modal';
import { useIntl } from 'react-intl';

const FirstConsentModal = ({ onAccept, onClose }: IModalChildProps) => {
    const intl = useIntl();
    return (
        <Modal>
            <>
                <div className="modal-content">
                    <div className="modal-header consent-header">
                        <h4 className="modal-title">
                            {intl.formatMessage({
                                id: 'GDPR_Consent_Modal',
                                defaultMessage: `Do you have patient consent to view protected
                            information relating to this device?`,
                            })}
                        </h4>
                    </div>
                    <div className="modal-footer consent-footer">
                        <button
                            type="button"
                            className="consent-button"
                            onClick={onAccept}
                        >
                            {intl.formatMessage({
                                id: 'Yes',
                                defaultMessage: 'Yes',
                            })}
                        </button>
                        <button
                            type="button"
                            style={{ marginLeft: '8px' }}
                            className="consent-button"
                            onClick={onClose}
                        >
                            {intl.formatMessage({
                                id: 'No',
                                defaultMessage: 'No',
                            })}
                        </button>
                    </div>
                </div>
            </>
        </Modal>
    );
};

export default FirstConsentModal;
